"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scopeTab = void 0;
var tabbable_1 = require("./tabbable");
function scopeTab(node, event) {
    var tabbable = tabbable_1.findTabbableDescendants(node);
    if (!tabbable.length) {
        event.preventDefault();
        return;
    }
    var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
    var leavingFinalTabbable = finalTabbable === document.activeElement || node === document.activeElement;
    if (!leavingFinalTabbable) {
        return;
    }
    event.preventDefault();
    var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
    if (target) {
        target.focus();
    }
}
exports.scopeTab = scopeTab;
